<script lang="ts">
    import { postLogout } from "../../../functions/CommerceAPIs/bigCommerce/customer"
</script>

<section class="small-wrapper">
    <h2>Dein Profil</h2>
    <button on:click="{postLogout}">Ausloggen</button>
</section>

<style lang="less">
    .small-wrapper {
        flex-grow: 1;
    }
</style>
